import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

const Lightbox = ({ images, initialIndex = 0, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  // 이전 이미지 보기
  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  // 다음 이미지 보기
  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") handlePrev(e);
      if (e.key === "ArrowRight") handleNext(e);
    };
    window.addEventListener("keydown", handleKeyDown);

    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "unset";
    };
  }, []);

  if (!images || images.length === 0) return null;

  return (
    <Overlay onClick={onClose}>
      <TopBar onClick={(e) => e.stopPropagation()}>
        <Counter>
          {currentIndex + 1} / {images.length}
        </Counter>
        <CloseBtn onClick={onClose}>&times;</CloseBtn>
      </TopBar>

      <NavBtn className="left" onClick={handlePrev}>
        &#10094;
      </NavBtn>

      <ImageContainer onClick={(e) => e.stopPropagation()}>
        <img
          src={images[currentIndex]}
          alt={`Gallery image ${currentIndex + 1}`}
        />
      </ImageContainer>

      <NavBtn className="right" onClick={handleNext}>
        &#10095;
      </NavBtn>
    </Overlay>
  );
};

export default Lightbox;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(10px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 0.3s ease-out;
`;

const TopBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10000;
  color: #fff;
`;

const Counter = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 2px;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 3rem;
  font-weight: 300;
  cursor: pointer;
  line-height: 1;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.2);
    color: #00d2ff;
  }
`;

const NavBtn = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 4rem;
  cursor: pointer;
  padding: 20px;
  z-index: 10000;
  transition: all 0.3s ease;

  &.left {
    left: 20px;
  }
  &.right {
    right: 20px;
  }

  &:hover {
    color: #fff;
    transform: translateY(-50%) scale(1.1);
  }
`;

const ImageContainer = styled.div`
  width: 80%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    user-select: none;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    animation: ${fadeIn} 0.4s ease-out;
  }
`;
